module.exports = __webpack_public_path__ + "assets/img/38-m.005bd3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/38-m.jpg
// module id = SAKm
// module chunks = 0